import {
    CLEAR_REGION_LIST,
    SET_REGION_LIST,
    REGION_CREATE_DIALOG_CLOSE,
    REGION_CREATE_DIALOG_OPEN,
    REGION_CREATE_ERROR,
    REGION_CREATE_ERROR_CLEAR,
    REGION_CREATE_PENDING,
    REGION_EDIT_DIALOG_CLOSE,
    REGION_EDIT_DIALOG_OPEN,
    REGION_EDIT_ERROR,
    REGION_EDIT_ERROR_CLEAR,
    REGION_EDIT_PENDING,
    REGION_LIST_ERROR,
    REGION_LIST_ERROR_CLEAR,
    REGION_LIST_PENDING,
    REGION_FILTER_DIALOG_OPEN,
    REGION_FILTER_DIALOG_CLOSE,
    SET_REGION_FILTER_DATA,
} from "./constants"


const initialState = {

    //-----------------------------|| LIST ||---------------------------------------------------------------
    regionList: null,
    regionListCount: 0,
    isRegionListPending: false,
    regionListErrorMessage: null,
    //-----------------------------|| FILTER ||-------------------------------------------------------------
    isRegionFilterDialogOpen: false,
    regionFilterData: null,
    //-----------------------------|| CREATE ||-------------------------------------------------------------
    isRegionCreateDialogOpen: false,
    isRegionCreatePending: false,
    regionCreateErrorMessage: null,
    //-----------------------------|| EDIT ||---------------------------------------------------------------
    isRegionEditDialogOpen: false,
    isRegionEditPending: false,
    regionEditErrorMessage: null,
}

const regions = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| LIST ||---------------------------------------------------------------
        case REGION_LIST_PENDING: {
            return {
                ...state,
                isRegionListPending: true,
                regionListErrorMessage: null,
            }
        }

        case SET_REGION_LIST: {
            const { regionList } = action.payload || {};
            return {
                ...state,
                regionList: regionList['value'],
                regionListCount: regionList['@odata.count'],
                isRegionListPending: false,
                regionListErrorMessage: null,
            }
        }

        case REGION_LIST_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                regionListErrorMessage: errorMessage,
                isRegionListPending: false,
                regionList: null,
                regionListCount: 0,
            }
        }

        case REGION_LIST_ERROR_CLEAR: {
            return {
                ...state,
                regionListErrorMessage: null,
                isRegionListPending: false,
            }
        }
        case CLEAR_REGION_LIST: {
            return {
                ...state,
                regionList: null,
                regionListCount: 0,
            }
        }

        //-----------------------------|| FILTER ||-------------------------------------------------------------
        case REGION_FILTER_DIALOG_OPEN: {
            return {
                ...state,
                isRegionFilterDialogOpen: true,
            }
        }
        case REGION_FILTER_DIALOG_CLOSE: {
            return {
                ...state,
                isRegionFilterDialogOpen: false,
            }
        }

        case SET_REGION_FILTER_DATA: {
            const { filter } = action.payload || {};
            return {
                ...state,
                regionFilterData: filter,
            }
        }

        //-----------------------------|| CREATE ||---------------------------------------------------------------
        case REGION_CREATE_DIALOG_OPEN: {
            return {
                ...state,
                isRegionCreateDialogOpen: true,
            }
        }
        case REGION_CREATE_DIALOG_CLOSE: {
            return {
                ...state,
                isRegionCreateDialogOpen: false,
            }
        }

        case REGION_CREATE_PENDING: {
            return {
                ...state,
                isRegionCreatePending: true,
                regionCreateErrorMessage: null,
            }
        }

        case REGION_CREATE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                regionCreateErrorMessage: errorMessage,
                isRegionCreatePending: false,
            }
        }

        case REGION_CREATE_ERROR_CLEAR: {
            return {
                ...state,
                regionCreateErrorMessage: null,
                isRegionCreatePending: false,
            }
        }

        //-----------------------------|| EDIT ||---------------------------------------------------------------
        case REGION_EDIT_DIALOG_OPEN: {
            return {
                ...state,
                isRegionEditDialogOpen: true,
            }
        }
        case REGION_EDIT_DIALOG_CLOSE: {
            return {
                ...state,
                isRegionEditDialogOpen: false,
            }
        }

        case REGION_EDIT_PENDING: {
            return {
                ...state,
                isRegionEditPending: true,
                regionEditErrorMessage: null,
            }
        }

        case REGION_EDIT_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                regionEditErrorMessage: errorMessage,
                isRegionEditPending: false,
            }
        }

        case REGION_EDIT_ERROR_CLEAR: {
            return {
                ...state,
                regionEditErrorMessage: null,
                isRegionEditPending: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default regions;